import * as types from "./mutationTypes";

export default {
  [types.SET_TRACK_USERS](state, users) {
    state.trackUsers = users;
  },
  [types.CLEAR_TRACK_USERS](state) {
    state.trackUsers = null;
  },
  [types.SET_USERS](state, users) {
    state.users = users;
  },
  [types.CLEAR_USERS](state) {
    state.users = null;
  },
  [types.SET_TOTAL_USERS](state, total) {
    state.totalUsers = total;
  },
  [types.CLEAR_TOTAL_USERS](state) {
    state.totalUsers = null;
  },
  [types.SET_INVITE](state, invite) {
    state.invite = invite;
  },
  [types.CLEAR_INVITE](state) {
    state.invite = null;
  },
  [types.SET_EMAILS](state, emails) {
    state.invite.emails = emails;
  },
  [types.SET_TEAM](state, teamUUID) {
    state.invite.team_uuid = teamUUID;
  }
};
